import { Building2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/components/ui/label';
import { SimpleSelect, type SelectOption } from '@/shared/ui/filters';

interface OrganizationSelectFilterProps {
  options: SelectOption[];
  value?: string;
  onChange: (value: string | undefined) => void;
  onSearchChange?: (value: string) => void;
  className?: string;
  isLoading?: boolean;
}

export function OrganizationSelectFilter({
  options,
  value,
  onChange,
  onSearchChange,
  className = 'w-full md:w-60',
  isLoading = false
}: OrganizationSelectFilterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex min-w-0 flex-col gap-2">
      <Label className="min-w-0 text-sm font-medium">
        <Building2 className="h-4 w-4 shrink-0" />
        <span className="truncate">{t('cmrlist.sender.label')}</span>
      </Label>
      <SimpleSelect
        options={options}
        value={value}
        onChange={onChange}
        onInputValueChange={onSearchChange}
        placeholder={isLoading ? t('common.loading') : t('newcmr.senderorg.label')}
        className={className}
      />
    </div>
  );
}
